var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: { filterable: "", placeholder: "Select timezone" },
          on: { change: _vm.updateTimezone },
          model: {
            value: _vm.selectedLocation,
            callback: function ($$v) {
              _vm.selectedLocation = $$v
            },
            expression: "selectedLocation",
          },
        },
        _vm._l(_vm.timezones, function (group) {
          return _c(
            "el-option-group",
            { key: group.label, attrs: { label: group.label } },
            _vm._l(group.options, function (timezone, index) {
              return _c(
                "el-option",
                { key: index, attrs: { value: timezone.label } },
                [
                  _c("span", [_c("i", { staticClass: "el-icon-location" })]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(timezone.label) + " (" + _vm._s(timezone.tz) + ") "
                    ),
                  ]),
                ]
              )
            }),
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "el-input el-input--small",
          staticStyle: { width: "fit-content", "font-size": "13px" },
        },
        [_vm._v("\n    " + _vm._s(_vm.currentLocation.tz) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "span",
        [
          _c(
            "el-tooltip",
            {
              staticClass: "info",
              attrs: {
                content: "The customer's timezone is selected by default",
              },
            },
            [_c("i", { staticClass: "el-icon-info" })]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }